import styles from '@/app/lcv/components/sections/spartan/products/hero-banner/overlays/styles.module.css';
import type {
  SpartanProductHeroBannerOverlay,
  SpartanProductHeroBannerOverlayConfig,
  SpartanProductHeroBannerOverlayLayer,
  SpartanProductHeroBannerOverlayPreset,
  SpartanProductHeroBannerOverlayStack,
} from '@/app/lcv/components/sections/spartan/products/hero-banner/types';

export const SPARTAN_HERO_BANNER_DEFAULT_OVERLAY_STACK: SpartanProductHeroBannerOverlayStack =
  'over-environment';

export const SPARTAN_HERO_BANNER_OVERLAY_PRESETS = {
  'v-cross': {
    top: {
      className: styles.vCrossTop,
    },
    bottom: {
      className: styles.vCrossBottom,
      stack: 'over-foreground',
    },
  },
  'mu-x': {
    top: {
      className: styles.muXRsTop,
    },
  },
  'mu-x-ultimate': {
    bottom: {
      className: styles.muXUltimateBottom,
      stack: 'over-foreground',
    },
  },
  'mu-x-elegant': {
    top: { className: styles.muXElegantTop, multiply: false },
    bottom: {
      className: styles.muXElegantBottom,
      stack: 'over-foreground',
    },
  },
  'mu-x-active': {
    top: { className: styles.muXActiveTop, multiply: false },
    bottom: {
      className: styles.muXActiveBottom,
      stack: 'over-foreground',
    },
  },
  'pickup-4-door': {
    top: { className: styles.pickup4DoorTop },
  },
  'pickup-2-door': {
    top: { className: styles.pickup2DoorTop },
    bottom: {
      className: styles.pickup2DoorBottom,
      stack: 'over-foreground',
    },
  },
  spark: {
    top: { className: styles.sparkTop },
    bottom: {
      className: styles.sparkBottom,
      stack: 'over-foreground',
    },
  },
} as const satisfies Record<
  SpartanProductHeroBannerOverlayPreset,
  SpartanProductHeroBannerOverlayConfig
>;

export const SPARTAN_HERO_BANNER_DEFAULT_OVERLAY_PRESET: SpartanProductHeroBannerOverlayPreset =
  'v-cross';

export const resolveSpartanProductHeroBannerOverlay = (
  overlay?: SpartanProductHeroBannerOverlay
): SpartanProductHeroBannerOverlayConfig =>
  SPARTAN_HERO_BANNER_OVERLAY_PRESETS[
    overlay ?? SPARTAN_HERO_BANNER_DEFAULT_OVERLAY_PRESET
  ];

const matchesOverlayStack = (
  layer: SpartanProductHeroBannerOverlayLayer | undefined,
  stack: SpartanProductHeroBannerOverlayStack
) => (layer?.stack ?? SPARTAN_HERO_BANNER_DEFAULT_OVERLAY_STACK) === stack;

export const filterSpartanProductHeroBannerOverlayByStack = (
  overlay: SpartanProductHeroBannerOverlayConfig,
  stack: SpartanProductHeroBannerOverlayStack
): SpartanProductHeroBannerOverlayConfig | null => {
  const top = matchesOverlayStack(overlay.top, stack) ? overlay.top : undefined;
  const bottom = matchesOverlayStack(overlay.bottom, stack)
    ? overlay.bottom
    : undefined;

  if (!top && !bottom) return null;

  return {
    ...(top ? { top } : {}),
    ...(bottom ? { bottom } : {}),
  };
};
